export const base_table = { page: 1, per_page: 100, order_by: "name", order_dir: "asc" };

export const base_table_purchase = { page: 1, per_page: 100, order_by: "created_at", order_dir: "desc" };

export const base_object = {
	databases: [],
};

export const TABS = [
	{ key: "base", label: "Formulario Base" },
	{ key: "db", label: "Bases de Datos" },
	{ key: "fields", label: "Campos" },
	{ key: "products", label: "Productos" },
];
